import { Controller } from "stimulus"
import $ from "jquery"
import debounce from "lodash/debounce"

export default class extends Controller {
  static targets = [
    "form", "input",
    "deeplinkUrl", "linkType", "externalUrl", "appDeeplinkDisplay", "appDeeplinkField", "externalUrlField", 
    "origin", "originTerminal", "originTt", "originCity",
    "destination", "destinationTerminal", "destinationTt", "destinationCity",
    "coupon", "appDeeplinkName", "routeFields"
  ]

  connect() {
    this.initInputEvents();
    this.initializeAutocomplete();
    this.toggleUrlFields();
  }

  initInputEvents() {
    if (this.hasInputTarget) {
      this.inputTargets.forEach(input => {
        if (input.tagName === "SELECT") {
          $(input).on("change", this.submitForm.bind(this));
        } else {
          $(input).on("input", debounce(this.submitForm.bind(this), 500));
        }
      })
    }
  }

  submitForm(event) {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    }
  }

  initializeAutocomplete() {
    if (!this.hasOriginTarget || !this.hasDestinationTarget) {
      return;
    }

    const categories = [
      { listLocation: "codes", maxNumberOfElements: 30, header: "C ó d i g o s :" },
      { listLocation: "terminals", maxNumberOfElements: 30, header: "T e r m i n a l e s :" },
      { listLocation: "cities", maxNumberOfElements: 30, header: "C i u d a d e s :" }
    ];
    
    const template = {
      type: "description",
      fields: { description: "transporter" }
    };
    
    const cats = ["tt", "terminal", "city"];

    const self = this;

    const originOptions = {
      url: function(phrase) {
        return "/promotions/search?place=" + phrase;
      },
      categories,
      getValue: function(element) {
        return element.name;
      },
      template,
      list: {
        maxNumberOfElements: 99,
        match: { enabled: true },
        sort: { enabled: true },
        onSelectItemEvent: function() {
          const selectedItem = $("#promotion_origin").getSelectedItemData();
          
          const valueCat = selectedItem.category;
          const valueId = selectedItem.id;
  
          $(`#promotion_origin_${valueCat}`).val(valueId).trigger("change");
          self.originTarget.setAttribute("data-slug", selectedItem.slug);
          
          const nullCats = cats.filter(c => c !== valueCat);
          nullCats.forEach(c => $(`#promotion_origin_${c}`).val(null).trigger("change"));
        }
      }
    };
    
    const destinationOptions = {
      url: function(phrase) {
        return "/promotions/search?place=" + phrase;
      },
      categories,
      getValue: function(element) {
        return element.name;
      },
      template,
      list: {
        maxNumberOfElements: 99,
        match: { enabled: true },
        sort: { enabled: true },
        onSelectItemEvent: function() {
          const selectedItem = $("#promotion_destination").getSelectedItemData();

          const valueCat = selectedItem.category;
          const valueId = selectedItem.id;
          
          $(`#promotion_destination_${valueCat}`).val(valueId).trigger("change");
          self.destinationTarget.setAttribute("data-slug", selectedItem.slug);
          
          const nullCats = cats.filter(c => c !== valueCat);
          nullCats.forEach(c => $(`#promotion_destination_${c}`).val(null).trigger("change"));
        }
      }
    };
    
    $(this.originTarget).easyAutocomplete(originOptions);
    $(this.destinationTarget).easyAutocomplete(destinationOptions);
    
    
    $(this.originTarget).on("change", () => {
      this.originTerminalTarget.value = null;
      this.originTtTarget.value = null;
      this.originCityTarget.value = null;
    });

    $(this.destinationTarget).on("change", () => {
      this.destinationTerminalTarget.value = null;
      this.destinationTtTarget.value = null;
      this.destinationCityTarget.value = null;
    });
  }

  toggleUrlFields() {
    const linkType = this.linkTypeTargets.find(e => e.checked).value;
    
    if (linkType === 'app') {
      this.appDeeplinkFieldTarget.style.display = 'block';
      this.externalUrlFieldTarget.style.display = 'none';
      this.routeFieldsTarget.style.display = 'flex';
      
      const appDeeplink = this.appDeeplinkNameTarget.value;
      this.appDeeplinkDisplayTarget.value = appDeeplink;
    } else {
      this.appDeeplinkFieldTarget.style.display = 'none';
      this.externalUrlFieldTarget.style.display = 'block';
      this.routeFieldsTarget.style.display = 'none';
    }
  }

  generateDeeplink() {
    const linkType = this.linkTypeTargets.find(e => e.checked).value;
  
    let baseUrl = '';
    let deeplinkUrl = '';
    if (linkType === 'app') {
      const originSlug = this.originTarget.getAttribute("data-slug") || this.originTarget.value;
      const destinationSlug = this.destinationTarget.getAttribute("data-slug") || this.destinationTarget.value;

      if (!originSlug || !destinationSlug) {
        alert('Por favor complete los campos de origen y destino para generar el deeplink.');
        return;
      } else if (!this.appDeeplinkDisplayTarget.value) {
        alert('Por favor ingrese un nombre para el deeplink de la aplicación.');
        return;
      }

      const appSeparator = '://';
      baseUrl = this.appDeeplinkDisplayTarget.value;
      baseUrl = baseUrl.endsWith(appSeparator) ? baseUrl : `${baseUrl}${appSeparator}`;

      const coupon = this.couponTarget.value || '';
      deeplinkUrl = `${baseUrl}search/${originSlug}/${destinationSlug}`;

      if (coupon) {
        deeplinkUrl += `?coupon=${coupon}`;
      }
    } else {
      if (!this.externalUrlTarget.value) {
        alert('Por favor ingrese una URL externa.');
        return;
      }

      baseUrl = this.externalUrlTarget.value || '';
      deeplinkUrl = baseUrl;
    }

    this.deeplinkUrlTarget.value = deeplinkUrl;
  }
} 